import BTC_Img from '../../assets/images/cryptocurrency/BTC.png';
import ETH_Img from '../../assets/images/cryptocurrency/ETH.png';
import DSH_Img from '../../assets/images/cryptocurrency/DASH.png';
import ZEC_Img from '../../assets/images/cryptocurrency/ZEC.png';
import TUS_Img from '../../assets/images/cryptocurrency/USDT.png';
import USDC_Img from '../../assets/images/cryptocurrency/USDC.png';
import SOL_Img from '../../assets/images/cryptocurrency/SOL.png';
import MATIC_Img from '../../assets/images/cryptocurrency/MATIC.png';
import XMR_Img from '../../assets/images/cryptocurrency/XMR.png';
import ETC_Img from '../../assets/images/cryptocurrency/ETC.png';
import LINK_Img from '../../assets/images/cryptocurrency/LINK.png';
import SHB_Img from '../../assets/images/cryptocurrency/SHIB.png';
import DAI_Img from '../../assets/images/cryptocurrency/DAI.png';
import BNB_Img from '../../assets/images/cryptocurrency/BNB.png';
import XRP_Img from '../../assets/images/cryptocurrency/XRP.png';
import DOG_Img from '../../assets/images/cryptocurrency/DOGE.png';
import TRX_Img from '../../assets/images/cryptocurrency/TRX.png';
import LTC_Img from '../../assets/images/cryptocurrency/LTC.png';
import BCH_Img from '../../assets/images/cryptocurrency/BCH.png';
import ARS_Img from '../../assets/images/cryptocurrency/ARS.png';
import JPY_Img from '../../assets/images/cryptocurrency/CNH.png';
import GBP_Img from '../../assets/images/cryptocurrency/GBP.png';
import RUB_Img from '../../assets/images/cryptocurrency/RUB.png';
import CAD_Img from '../../assets/images/cryptocurrency/CAD.png';
import EUR_Img from '../../assets/images/cryptocurrency/EUR.png';
import INR_Img from '../../assets/images/cryptocurrency/INR.png';
import USD_Img from '../../assets/images/cryptocurrency/USD.png';

export const cryptoCurrencies = {
  BTC: 'bitcoin',
  ETH: 'ethereum',
  DSH: 'dash',
  ZEC: 'z-cash',
  TUS: 'tether',
  USDC: 'usd-coin',
  SOL: 'solana ',
  MATIC: 'polygon',
  XMR: 'moreno',
  ETC: 'ethereum-classic',
  LINK: 'chain-link',
  SHB: 'shiba-inu',
  DAI: 'dai',
  BNB: 'binance-coin',
  XRP: 'xrp-coin',
  DOG: 'doge',
  TRX: 'trx-coin',
  LTC: 'lite-coin',
  BCH: 'bitcoin-cash',
  ARS: 'ars',
  JPY: 'jpy',
  GBP: 'gbp',
  RUB: 'rub',
  CAD: 'cad',
  EUR: 'eur',
  INR: 'inr',
  USD: 'usd',
};

export const cryptoCurrencyImages = {
  BTC: BTC_Img,
  ETH: ETH_Img,
  DSH: DSH_Img,
  ZEC: ZEC_Img,
  TUS: TUS_Img,
  USDC: USDC_Img,
  SOL: SOL_Img,
  MATIC: MATIC_Img,
  XMR: XMR_Img,
  ETC: ETC_Img,
  LINK: LINK_Img,
  SHB: SHB_Img,
  DAI: DAI_Img,
  BNB: BNB_Img,
  XRP: XRP_Img,
  DOG: DOG_Img,
  TRX: TRX_Img,
  LTC: LTC_Img,
  BCH: BCH_Img,
  ARS: ARS_Img,
  JPY: JPY_Img,
  GBP: GBP_Img,
  RUB: RUB_Img,
  CAD: CAD_Img,
  EUR: EUR_Img,
  INR: INR_Img,
  USD: USD_Img,
};
